import { ChannelType } from "./ChannelType";
import SignalType from "./SignalType";
import SignalTypes from "./SignalTypes";
import Logger from "../Logger";

const logger = new Logger();
export class SignalBundleDefinition {
  basicSignals: Array<SignalType>;
  extendedSignals?: Array<SignalType>;

  constructor(params: { basicSignals: Array<SignalType>; extendedSignals?: Array<SignalType> }) {
    this.basicSignals = params.basicSignals;
    this.extendedSignals = params.extendedSignals;
  }

  matchN(signal: SignalType, signalTypes: Array<SignalType>): boolean {
    var res = false;
    signalTypes.forEach((s) => {
      res ||= s.name == signal.name;
    });
    return res;
  }

  evalExpression(expression: any, signals: Array<SignalType>): boolean {
    if (expression.or) {
      var res = false;
      if (Array.isArray(expression.or)) {
        (expression.or as Array<any>).forEach((orElement) => {
          res ||= this.matchN(orElement, signals);
        });
      } else {
        res ||= this.evalExpression(expression.or, signals);
      }

      return res;
    } else if (expression.and) {
      var res = true;
      if (Array.isArray(expression.and)) {
        (expression.or as Array<any>).forEach((orElement) => {
          res &&= this.matchN(orElement, signals);
        });
      } else {
        res &&= this.evalExpression(expression.and, signals);
      }

      return res;
    } else {
      logger.error("invalid expression", expression);

      return false;
    }
  }
}

export const signalBundleDefinitions = new Map<ChannelType, SignalBundleDefinition>();

// let _signalBundleDefinitions: Map<ChannelType, SignalBundleDefinition> | undefined;

// export get signalBundleDefinitions(): Map<ChannelType, SignalBundleDefinition> {
//   _signalBundleDefinitions = new Map<ChannelType, SignalBundleDefinition>();
//   return _signalBundleDefinitions;
// }

export function initSignalBundleDefinitions() {
  signalBundleDefinitions.clear();

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Switch
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_Switch = new SignalBundleDefinition({
    basicSignals: [SignalTypes.Switch, SignalTypes.SwitchStatus, SignalTypes.delayTime],
  });

  // if (state.settings.groupAddresses.useLockForSwitch) {
  //   signalBundleDefinition_Switch.basicSignals.push(SignalTypes.Lock);
  // }

  signalBundleDefinitions.set(ChannelType.Switch, signalBundleDefinition_Switch);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Switch
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_StaircaseLight = new SignalBundleDefinition({
    basicSignals: [SignalTypes.StaircaseLight, SignalTypes.Switch, SignalTypes.SwitchStatus, SignalTypes.delayTime],
  });

  // if (state.settings.groupAddresses.useLockForSwitch) {
  //   signalBundleDefinition_StaircaseLight.basicSignals.push(SignalTypes.Lock);
  // }

  signalBundleDefinitions.set(ChannelType.StaircaseLight, signalBundleDefinition_StaircaseLight);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Dimmer
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_Dimmer = new SignalBundleDefinition({
    basicSignals: [
      SignalTypes.Switch,
      SignalTypes.SwitchStatus,
      SignalTypes.delayTime,

      SignalTypes.DimValue,
      SignalTypes.DimValueStatus,
      SignalTypes.DimStep,

      SignalTypes.DimRemessure,
    ],
  });

  // if (state.settings.groupAddresses.useLockForSwitch) {
  //   signalBundleDefinition_Dimmer.basicSignals.push(SignalTypes.Lock);
  // }

  signalBundleDefinitions.set(ChannelType.Dimmer, signalBundleDefinition_Dimmer);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Tuneable White
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_TuneableWhite = new SignalBundleDefinition({
    basicSignals: [
      SignalTypes.Switch,
      SignalTypes.SwitchStatus,
      SignalTypes.delayTime,

      SignalTypes.DimValue,
      SignalTypes.DimValueStatus,
      SignalTypes.DimStep,

      SignalTypes.ColorTemperatureStep,
      SignalTypes.ColorTemperatureKelvin,
      SignalTypes.ColorTemperatureKelvinStatus,

      SignalTypes.TWColdWhiteValue,
      SignalTypes.TWColdWhiteValueStatus,
      SignalTypes.TWColdWhiteStep,

      SignalTypes.TWWarmWhiteValue,
      SignalTypes.TWWarmWhiteValueStatus,
      SignalTypes.TWWarmWhiteStep,

      SignalTypes.TunableWhiteTransitionValue,
      SignalTypes.TunableWhiteTransitionValueStatus,
      SignalTypes.TunableWhiteTransitionStep,

      SignalTypes.ColorTemperaturePercent,
      SignalTypes.ColorTemperaturePercentStatus,
      SignalTypes.ColorTemperatureStep,

      SignalTypes.TunableWhiteBrightnessTransition249_600,
    ],
  });

  signalBundleDefinitions.set(ChannelType.TuneableWhite, signalBundleDefinition_TuneableWhite);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // RGB
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_RGB = new SignalBundleDefinition({
    basicSignals: [
      SignalTypes.Switch,
      SignalTypes.SwitchStatus,
      SignalTypes.delayTime,

      SignalTypes.DimValue,
      SignalTypes.DimValueStatus,
      SignalTypes.DimStep,

      SignalTypes.RGBValue,
      SignalTypes.RGBStep,
      SignalTypes.RGBValueStatus,

      SignalTypes.RGBValue6Byte,
      SignalTypes.RGBValueStatus6Byte,

      SignalTypes.HSVValue,
      SignalTypes.HSVStep,
      SignalTypes.HSVValueStatus,

      SignalTypes.RGBBlueSwitch,
      SignalTypes.RGBBlueSwitchStatus,
      SignalTypes.RGBBlueStep,
      SignalTypes.RGBBlueValue,
      SignalTypes.RGBBlueValueStatus,

      SignalTypes.RGBRedSwitch,
      SignalTypes.RGBRedSwitchStatus,
      SignalTypes.RGBRedStep,
      SignalTypes.RGBRedValue,
      SignalTypes.RGBRedValueStatus,

      SignalTypes.RGBGreenSwitch,
      SignalTypes.RGBGreenSwitchStatus,
      SignalTypes.RGBGreenStep,
      SignalTypes.RGBGreenValue,
      SignalTypes.RGBGreenValueStatus,

      SignalTypes.RGBWhiteSwitch,
      SignalTypes.RGBWhiteSwitchStatus,
      SignalTypes.RGBWhiteStep,
      SignalTypes.RGBWhiteValue,
      SignalTypes.RGBWhiteValueStatus,

      SignalTypes.HSV_ColorValue,
      SignalTypes.HSV_ColorValueStatus,

      SignalTypes.HSV_HueValue,
      SignalTypes.HSV_HueStep,
      SignalTypes.HSV_HueValueStatus,

      SignalTypes.HSV_SaturationValue,
      SignalTypes.HSV_SaturationStep,
      SignalTypes.HSV_SaturationValueStatus,
      SignalTypes.ColorTemperatureStep,

      SignalTypes.ColorTemperatureKelvin,
      SignalTypes.ColorTemperatureKelvinStatus,

      SignalTypes.ColorTemperaturePercent,
      SignalTypes.ColorTemperaturePercentStatus,

      SignalTypes.TWColdWhiteValue,
      SignalTypes.TWColdWhiteValueStatus,
      SignalTypes.TWColdWhiteStep,
      SignalTypes.TWWarmWhiteValue,
      SignalTypes.TWWarmWhiteValueStatus,
      SignalTypes.TWWarmWhiteStep,
      SignalTypes.TunableWhiteTransitionValue,
      SignalTypes.TunableWhiteTransitionValueStatus,
      SignalTypes.TunableWhiteTransitionStep,
      SignalTypes.TunableWhiteBrightnessTransition249_600,
    ],
  });

  signalBundleDefinitions.set(ChannelType.Rgb, signalBundleDefinition_RGB);
  /////////////////////////////////////////////////////////////////////////////////////////////
  // RGBW
  /////////////////////////////////////////////////////////////////////////////////////////////

  // const signalBundleDefinition_RGBW = new SignalBundleDefinition({
  //   basicSignals: [
  //     SignalTypes.Switch,
  //     SignalTypes.SwitchStatus,

  //     SignalTypes.DimValue,
  //     SignalTypes.DimValueStatus,
  //     SignalTypes.DimStep,

  //     SignalTypes.ColorTemperatureStep,

  //     SignalTypes.ColorTemperatureKelvinValue,
  //     SignalTypes.ColorTemperatureKelvinValueStatus,

  //     SignalTypes.ColorTemperaturePercentColdWhite,
  //     SignalTypes.ColorTemperaturePercentColdWhiteStatus,

  //     SignalTypes.RGBWStatus,
  //     SignalTypes.RGB,
  //     SignalTypes.RGBStatus,

  //     SignalTypes.RGBValue,
  //     SignalTypes.RGBValueStatus,
  //     SignalTypes.HSVValue,

  //     SignalTypes.RGBBlueSwitch,
  //     SignalTypes.RGBBlueSwitchStatus,
  //     SignalTypes.RGBBlueStep,
  //     SignalTypes.RGBBlueValue,
  //     SignalTypes.RGBBlueValueStatus,

  //     SignalTypes.RGBRedSwitch,
  //     SignalTypes.RGBRedSwitchStatus,
  //     SignalTypes.RGBRedStep,
  //     SignalTypes.RGBRedValue,
  //     SignalTypes.RGBRedValueStatus,

  //     SignalTypes.RGBGreenSwitch,
  //     SignalTypes.RGBGreenSwitchStatus,
  //     SignalTypes.RGBGreenStep,
  //     SignalTypes.RGBGreenValue,
  //     SignalTypes.RGBGreenValueStatus,

  //     SignalTypes.HSV_ColorSetting,
  //     SignalTypes.DimValueRgbStatus,
  //     SignalTypes.DimValueHsvStatus,

  //     SignalTypes.HSV_HueValue,
  //     SignalTypes.HSV_HueStep,
  //     SignalTypes.HSV_HueValueStatus,

  //     SignalTypes.HSV_SaturationValue,
  //     SignalTypes.HSV_SaturationStep,
  //     SignalTypes.HSV_SaturationValueStatus,

  //     SignalTypes.HSV_BrightnessValue,
  //     SignalTypes.HSV_BrightnessStep,
  //     SignalTypes.HSV_BrightnessValueStatus,
  //   ],
  // });
  // signalBundleDefinitions.set(ChannelType.Rgbw, signalBundleDefinition_RGBW);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // TemperatureMeasurement
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_TemperatureMeasurement = new SignalBundleDefinition({
    basicSignals: [SignalTypes.Temperature_Current],
  });
  signalBundleDefinitions.set(ChannelType.TemperatureMeasurement, signalBundleDefinition_TemperatureMeasurement);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Heating
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_Heating = new SignalBundleDefinition({
    basicSignals: [
      SignalTypes.Temperature_Current,

      SignalTypes.Temperature_Target,
      SignalTypes.Temperature_TargetStatus,

      SignalTypes.Temperature_TargetComfort,
      SignalTypes.Temperature_TargetComfortStatus,

      SignalTypes.Temperature_TargetShift_9,
      SignalTypes.Temperature_TargetShift_9_Status,

      SignalTypes.Temperature_TargetShift_6,
      SignalTypes.Temperature_TargetShift_6_Status,

      SignalTypes.Temperature_TargetStep_1,

      // valve-%-of-open-time
      SignalTypes.Temperature_ControlValue,
      SignalTypes.Temperature_ControlValueStatus,

      // Valve open/close
      SignalTypes.Temperature_ValveState,
      SignalTypes.Temperature_ValveStateStatus,

      //
      // Nur einmal für alle Im Environment....
      // Das müsste man ggfls später mal in den ProjectSettings konfigurieren
      //

      SignalTypes.OperationMode,
      SignalTypes.OperationMode_Status,

      SignalTypes.Temperature_Heating_Status,

      // SignalTypes.OperationMode_Comfort,
      // SignalTypes.OperationMode_Night,
      // SignalTypes.OperationMode_Frost,
    ],
  });
  signalBundleDefinitions.set(ChannelType.Heating, signalBundleDefinition_Heating);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Heating (Setpoint)
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_TemperaturSetpoint = new SignalBundleDefinition({
    basicSignals: [
      SignalTypes.Temperature_Current,

      SignalTypes.Temperature_Target,
      SignalTypes.Temperature_TargetStatus,

      SignalTypes.Temperature_TargetShift_9,
      SignalTypes.Temperature_TargetShift_9_Status,

      SignalTypes.Temperature_TargetShift_6,
      SignalTypes.Temperature_TargetShift_6_Status,

      SignalTypes.Temperature_TargetStep_1,

      SignalTypes.OperationMode,
      SignalTypes.OperationMode_Status,
      SignalTypes.Temperature_CurrentDisplay,

      //
      // MWE 10.3.2026
      //
      // für LS Touch RTR Actor Chanal
      //
      SignalTypes.Temperature_ControlValue,
      SignalTypes.Temperature_ControlValueStatus,

      SignalTypes.Temperature_ValveState,
      SignalTypes.Temperature_ValveStateStatus,
    ],
  });
  signalBundleDefinitions.set(ChannelType.TemperatureSetpoint, signalBundleDefinition_TemperaturSetpoint);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Heating (OperationMode)
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_OperationMode = new SignalBundleDefinition({
    basicSignals: [SignalTypes.OperationMode, SignalTypes.OperationMode_Status],
  });
  signalBundleDefinitions.set(ChannelType.OperationMode, signalBundleDefinition_OperationMode);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Blind
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_Blind = new SignalBundleDefinition({
    basicSignals: [
      SignalTypes.BlindMove,
      SignalTypes.BlindStopStep,

      SignalTypes.BlindPosition,
      SignalTypes.BlindPositionStatus,

      SignalTypes.BlindDirectionStatus,
      SignalTypes.BlindDirectionValue,

      SignalTypes.BlindMoveStatus,

      SignalTypes.BlindDownRunning,
      SignalTypes.BlindUpRunning,

      SignalTypes.BlindTopStatus,
      SignalTypes.BlindBottomStatus,

      SignalTypes.SlatPosition,
      SignalTypes.SlatPositionStatus,

      SignalTypes.BlindStartRefDrive,

      SignalTypes.Lock,
      SignalTypes.LockStatus,

      SignalTypes.BlindSingleObjectControl,
    ],
  });

  // if (state.settings.groupAddresses.useLockForSwitch) {
  //   signalBundleDefinition_Blind.basicSignals.push(SignalTypes.Lock);
  // }

  signalBundleDefinitions.set(ChannelType.Blind, signalBundleDefinition_Blind);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Jalousie
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_Jalousie = new SignalBundleDefinition({
    basicSignals: [
      ...signalBundleDefinition_Blind.basicSignals,
      SignalTypes.SlatPosition,
      SignalTypes.SlatPositionStatus,
    ],
  });

  signalBundleDefinitions.set(ChannelType.Jalousie, signalBundleDefinition_Jalousie);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Scene
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_Scene = new SignalBundleDefinition({
    basicSignals: [],
  });

  signalBundleDefinitions.set(ChannelType.Scene, signalBundleDefinition_Scene);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Lock
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_Lock = new SignalBundleDefinition({
    basicSignals: [SignalTypes.Lock],
  });

  signalBundleDefinitions.set(ChannelType.Lock, signalBundleDefinition_Lock);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Environment
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_Environment = new SignalBundleDefinition({
    basicSignals: [
      SignalTypes.Date,
      SignalTypes.DateTime,
      SignalTypes.Time,
      SignalTypes.DayNight,
      SignalTypes.WinterSummer,
      SignalTypes.EnvironmentBrightness,
      SignalTypes.EnvironmentTemperature,
      SignalTypes.EnvironmentHumidity,
      SignalTypes.Diagnostic,
      SignalTypes.EnvironmentWindAlarm,
      SignalTypes.EnvironmentFrostAlarm,
      SignalTypes.EnvironmentHeatAlarm,
      SignalTypes.EnvironmentRainAlarm,
      SignalTypes.EnvironmentError,

      // Operation Modes
      SignalTypes.OperationMode,
      SignalTypes.OperationMode_Comfort,
      SignalTypes.OperationMode_Night,
      SignalTypes.OperationMode_FrostProtection,
      SignalTypes.OperationMode_HeatProtection,

      // Scenes
      // SignalTypes.Scene, // included again 6.2.2026
      // excluded again 26.3.2026 because now we add the scene signal of all bundles
      //
    ],
  });

  signalBundleDefinitions.set(ChannelType.Environment, signalBundleDefinition_Environment);

  /////////////////////////////////////////////////////////////////////////////////////////////
  // StatusSwitch
  /////////////////////////////////////////////////////////////////////////////////////////////

  const signalBundleDefinition_StatusDisplaySwitch = new SignalBundleDefinition({
    basicSignals: [SignalTypes.StatusDisplaySwitch, SignalTypes.SwitchStatus],
  });

  signalBundleDefinitions.set(ChannelType.StatusDisplaySwitch, signalBundleDefinition_StatusDisplaySwitch);
}
